import { FOREIGN_ID_FIELD_BY_ENTITY_TYPE, MSG_ENTITY_TYPE_BY_FOREIGN_ENTITY_TYPE } from 'constants/ChatConstants';
import { PARTS } from 'constants/ModeConstants';
import { ENTITY_TYPE } from 'modules/app/constants';
import { getForeignInterventionId, getForeignInterventionType } from 'services/InterventionUtils';
import { createDictionary } from 'utils/ObjectUtils';

export const INTERVENTION_ID_FIELD_BY_MODULE = createDictionary(
  { [PARTS]: 'partsInterventionId' },
  'interventionId'
);

const ENTITY_FIELD_BY_ENTITY_TYPE_MODULE = createDictionary(
  {
    [ENTITY_TYPE.INTERVENTION]: INTERVENTION_ID_FIELD_BY_MODULE,
    [ENTITY_TYPE.CAMPAIGN]: createDictionary({}, 'campaignFileId'),
  },
  undefined
);

export const paramsFormatter = (entity, conversationId) => {
  const entityType = entity?.campaignId ? ENTITY_TYPE.CAMPAIGN : ENTITY_TYPE.INTERVENTION;
  const field = ENTITY_FIELD_BY_ENTITY_TYPE_MODULE[entityType][entity?.module];

  return {
    conversationId,
    [field]: entity?.id,
  };
};

/**
 * Resolves a set of foreign id params (e.g. `{ interventionId, campaignFileId, conversationId, ... }`)
 * into the `{ entityId, entityType }` mapping expected by the chat message API.
 * @param {Record<string, unknown>} [params={}]
 * @returns {import("./types").MessageEntityMapping}
 */
export const getMessageEntityMapping = (params = {}) => ({
  entityId: getForeignInterventionId(params),
  entityType: MSG_ENTITY_TYPE_BY_FOREIGN_ENTITY_TYPE[getForeignInterventionType(params)],
});

/**
 * Inverse of {@link getMessageEntityMapping}: turns an entity mapping into the foreign id filter
 * (e.g. `{ entityId, entityType: 'CAMPAIGN_FILE' }` → `{ campaignFileId: entityId }`) expected by the
 * message fetch filter. Returns an empty object when the mapping carries no resolvable entity.
 * @param {import("./types").MessageEntityMapping} [mapping={}]
 * @returns {Record<string, string>}
 */
export const getEntityFilterParams = ({ entityId, entityType } = {}) => {
  const field = FOREIGN_ID_FIELD_BY_ENTITY_TYPE[entityType];
  return field && entityId ? { [field]: entityId } : {};
};
